import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Divider,
    List,
    ListItem,
    ListItemText
} from "@mui/material";
import Header from '../../../components/header.tsx';
import Footer from '../../../components/footer.tsx';
import signInBanner1 from '../../../assets/signin_banner.jpg';
import signInBanner2 from '../../../assets/signin_banner1.jpeg';
import signInBanner3 from '../../../assets/signin_banner-2.jpeg';



const ResetNewPassword = () => {
    const sidebanner = [signInBanner1, signInBanner2, signInBanner3];
    const [bannercurrentIndex, setBannerCurrentIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setBannerCurrentIndex((prev) => (prev + 1) % sidebanner.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);
    return (
        <>
            {/* header */}
            <Header />
            {/* end header  */}

            {/* body */}
            <Box className="primary-box">

                {/* Left side with image ads */}
                <Box
                    className="secondary-box"
                    sx={{
                        padding: 2,
                    }}
                    display={{
                        xs: 'none',
                        md: 'block'
                    }}
                >
                    <img
                        src={sidebanner[bannercurrentIndex]}
                        alt="Ad Banner"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            width: '100%'
                        }}
                    />
                </Box>

                {/* password assistance card */}
                <Box className="secondary-box" sx={{ flexDirection: 'column' }}>
                    <Card className="auth-card"
                        sx={{
                            p: 3,
                            // width: '28%'
                        }}
                    >
                        {/* Logo */}
                        <Box className="auth-logo"
                            sx={{
                                mx: "auto",
                                mb: 2,
                                // width: '15%'
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "40px", color: "#fff", fontWeight: "bold" }}
                            >
                                F5
                            </Typography>
                        </Box>

                        {/* Title */}
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 2, textAlign: "left" }}
                        >
                            Create New Password
                        </Typography>
                        <Typography
                            sx={{ mb: 2, textAlign: "left", fontSize: '14px' }}
                        >
                            We'll ask for this password whenever you Sign-In.
                        </Typography>

                        <>
                            <TextField
                                fullWidth
                                type="password"
                                label="New Password"
                                /* value={password}
                                onChange={(e) => setPassword(e.target.value)} */
                                sx={{ mb: 2 }}
                                size="small"
                            />

                            <TextField
                                fullWidth
                                type="password"
                                label="Re-enter Password"
                                /* value={password}
                                onChange={(e) => setPassword(e.target.value)} */
                                sx={{ mb: 2 }}
                                size="small"
                            />
                        </>

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            // onClick={handleSubmit}
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                backgroundColor: "#C32032",
                                mb: 1,
                            }}
                        >
                            Save changes and Sign-In
                        </Button>
                    </Card>

                    <Box sx={{ width: '50%', mt: 2 }}>
                        <Typography sx={{ fontWeight: 'bold' }}>Security password tips:</Typography>
                        <Box component="ul" sx={{ listStyle: 'disc', pl: 2 }}>
                            <Box component="li"> Use atleast 8 characters, a combination of numbers and letters is best.</Box>
                            <Box component="li">Do not use the same password you have used with us previously.</Box>
                            <Box component="li">Do not use dictionary words, your name, e-mail address, mobile phone number or other personal information that can be easily obtained.</Box>
                            <Box component="li">Do not use the same password for multiple online accounts.</Box>

                        </Box>
                    </Box>
                    {/* <Divider sx={{ my: 2, width: '100%' }} />

                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#C32032',
                        }}
                    >
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Conditions of use</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Privacy Policy</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Help</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#666',
                            mt: 2
                        }}
                    >
                        <Typography>©2025, FortuneFive.com</Typography>
                    </Box> */}
                </Box>
            </Box>
            {/* body */}

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}

export default ResetNewPassword;